export default __webpack_public_path__ + "static/media/small.2930dad0.jpg";